import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Understand how food is processed and kept safe: food science, unit operations, sanitation and CIP, food microbiology, HACCP, allergens, traceability and quality control. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="sudoanf90dch">
      <MetaPixel data-id="element-1" data-mp="35ynugqx9fzv" />
      <main data-id="element-2" data-mp="35gnb7x88fm5">
        <Hero data-id="element-3" data-mp="34x1hg4gh72u" />
        <LookInsideCarousel data-id="element-4" data-mp="34ndfy2z19zs" />
        <ProblemSection data-id="element-5" data-mp="3uct0zcywiaxb" />
        <SystemSection data-id="element-6" data-mp="3udkn7x6lywax" />
        <ModulesSection data-id="element-7" data-mp="3uc9jtyh2rqkc" />
        <BonusSection data-id="element-8" data-mp="3uevuw836co7b" />
        <UrgencySection data-id="element-9" data-mp="d4e4fpsbp6v4" />
        <PricingSection data-id="element-10" data-mp="d3mlbefwx1lq" />
        <GuaranteeSection data-id="element-11" data-mp="d45vg8zbmlp7" />
        <FAQ data-id="element-12" data-mp="d2bhxfqdpvv5" />
        <ClosingSection data-id="element-13" data-mp="85uivqhn5x3a" />
        <SummaryTable data-id="element-14" data-mp="86mf93j2byum" />
        <FinalCta data-id="element-15" data-mp="8648ve2os48z" />
      </main>
      <Footer data-id="element-16" data-mp="83qdt580as1f" />
      <PurchaseNotification data-id="element-17" data-mp="3gl4rlhg1e0k1" />
    </div>;
}